import { render, staticRenderFns } from "./KeyboardBase.vue?vue&type=template&id=0655648a&scoped=true"
import script from "./KeyboardBase.vue?vue&type=script&lang=js"
export * from "./KeyboardBase.vue?vue&type=script&lang=js"
import style0 from "./KeyboardBase.vue?vue&type=style&index=0&id=0655648a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0655648a",
  null
  
)

export default component.exports